export default __webpack_public_path__ + "static/media/703.c97856d2.png";